// Pure weapon-selection helpers, lifted out of InputService so they're unit-testable without the DOM or a
// live connection (scripts/client-sim.js). The wheel-cycling + armed-slot logic moved INTO the hotbar
// plugins (Set 12.10 — the shooter hotbar is a plugin); only the cooldown check the fire path needs is left.

// Is the selected weapon still cooling down, so a click should flash the "denied" ring
// instead of firing? True only when the scoreboard reports a live cooldown.
export function coolingDown(score) {
    return !!(score && score.cdMax > 0 && score.cd > 0.05);
}
